import React from 'react';
import {Avatar, Link, List, ListItem, Sheet, Stack, Typography} from '@mui/joy';

import {ArrowUpward} from "@mui/icons-material";
import Divider from "@mui/joy/Divider";
import SocialNetwork from "./SocialNetwork";
import ContactInfo from "./ContactInfo";
import {SummaryModel} from "../model/summary";

function Footer({summary}: { summary: SummaryModel }) {
    return (<Sheet >
            <Stack paddingBottom={4} padding={4} spacing={6} direction='column' justifyContent='center' alignItems="center">
                <Stack width='100%' spacing={2} justifyContent='space-around' alignItems="start" direction={{xs: 'column', sm: 'row'}}>
                    <Stack spacing={1} justifyContent='start' alignItems="start" direction='column'>
                        <Typography level='body-md'>Follow Us</Typography>
                        <SocialNetwork summary={summary}/>
                    </Stack>
                    <Divider/>
                    <ContactInfo summary={summary}/>
                </Stack>
            </Stack>
        </Sheet>
    );
}

export default Footer;